var translations = {
    de: {
        title: 'Baufinanzierung anfragen',
        point_1: 'Attraktive Konditionen',
        point_2: 'Mehrere Banken im Vergleich',
        point_3: 'Unverbindliche Anfrage',
    },
};
export default translations;
